// extracted by mini-css-extract-plugin
export var messageSideLeft = "_hz-1";
export var messageSideRight = "_hz-2";
export var subscribeToBackInStockBubbleContainer = "_hz-0";